import { createDynamicSlice } from ".";
import { fetchPermissionsThunk } from "../thunks/permissionsThunk";

export const permissionsSlice = createDynamicSlice({
  name: "permissions",
  thunk: fetchPermissionsThunk,
  listMode: true,
  resetActionName: "resetPermissions",
});

export const permissionsReducer = permissionsSlice.reducer;
export const { resetPermissions } = permissionsSlice.actions;
